import {inlineError} from '@s-ui/decorators'

import DealerRepository from './DealerRepository.js'

export class EmptyDealerRepository extends DealerRepository {
  @inlineError
  getTrackingPhone() {}

  @inlineError
  setTrackingPhone() {}
}
